import { useCallback } from 'react';
import { SPECIAL_CHARS_FORMAT } from 'common/utils/constants';
import { checkStringForHTML } from 'common/utils/helpers';

function useValidateDeviceName() {
  return useCallback((value) => {
    const deviceName = value?.name || '';
    const errors = {};

    const trimmedDeviceName = deviceName.trim();

    if (trimmedDeviceName.length > 100) {
      errors.name = 'Number of characters should NOT excess 100';
    } else if (SPECIAL_CHARS_FORMAT.test(trimmedDeviceName)) {
      errors.name = 'Special character not allowed';
    } else if (checkStringForHTML(trimmedDeviceName)) {
      errors.name = 'HTML not allowed';
    }

    return errors;
  }, []);
}

export default useValidateDeviceName;
